import { useSelector } from "react-redux";
import ProductItem from "./ProductItem";
import ProductInput from "./ProductInput";

export default function ProductContainer() {
    const products = useSelector((state) => state.product.sort((a, b) => a.id - b.id));

    return (
        <div className="productWrapper">
            <div
                className="productContainer"
                id="lws-productContainer"
            >
                {products.length <= 0 && <h3>No Product Found</h3>}
                {products.map((p) => (
                    <ProductItem key={p.id} item={p} />
                ))}
            </div>
            <div>
                <ProductInput />
            </div>
        </div>
    );
}